/**
 * Neo4j's `_CONTAINS` is case-sensitive and the schema exposes no case-insensitive
 * matcher, so a single filter would miss "becker" for "Becker". Search the term as
 * typed, capitalised and lower-cased, plus the address — enough for how names and
 * e-mails are actually stored.
 */
export function profileSearchWhere(term: string): {
  OR: Array<{ listName_CONTAINS?: string; email_CONTAINS?: string }>;
} {
  const trimmed = term.trim();
  const capitalised = trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
  const variants = [...new Set([trimmed, capitalised, trimmed.toLowerCase()])];
  return {
    OR: [
      ...variants.map((listName_CONTAINS) => ({ listName_CONTAINS })),
      { email_CONTAINS: trimmed.toLowerCase() },
    ],
  };
}
